<template>
  <template v-if="rowConfig.type === GenericTableRowConfigType.LINK">
    <a
      v-if="isExternalLink(rowConfig.to(entity))"
      :href="rowConfig.disabled ? '' : (rowConfig.to(props.entity) as string)"
      class="table-row odd:bg-lightPrimaryColor even:bg-lightSecondaryColor hover:bg-white/5 dark:odd:bg-darkPrimaryColor dark:even:bg-darkSecondaryColor dark:hover:bg-white/20 md:h-xl"
      :class="[{ 'pointer-events-none': rowConfig.disabled, 'cursor-pointer': !rowConfig.disabled }, rowConfig.class?.(entity)]"
    >
      <slot></slot>
    </a>
    <RouterLink
      v-else
      class="table-row odd:bg-lightPrimaryColor even:bg-lightSecondaryColor hover:bg-white/5 dark:odd:bg-darkPrimaryColor dark:even:bg-darkSecondaryColor dark:hover:bg-white/20 md:h-xl"
      :class="[{ 'pointer-events-none': rowConfig.disabled, 'cursor-pointer': !rowConfig.disabled }, rowConfig.class?.(entity)]"
      :to="rowConfig.to(entity)"
    >
      <slot></slot>
    </RouterLink>
  </template>
  <div
    v-if="rowConfig.type === GenericTableRowConfigType.ACTION"
    role="button"
    class="table-row odd:bg-lightPrimaryColor even:bg-lightSecondaryColor hover:bg-white/5 dark:odd:bg-darkPrimaryColor dark:even:bg-darkSecondaryColor dark:hover:bg-white/20 md:h-xl"
    :class="rowConfig.class?.(entity)"
    @click="rowConfig.onClick(entity)"
    @keydown.enter="rowConfig.onClick(entity)"
    @keydown.space="rowConfig.onClick(entity)"
  >
    <slot> </slot>
  </div>
  <div
    v-if="rowConfig.type === GenericTableRowConfigType.NONE"
    class="table-row odd:bg-lightPrimaryColor even:bg-lightSecondaryColor hover:bg-white/5 dark:odd:bg-darkPrimaryColor dark:even:bg-darkSecondaryColor dark:hover:bg-white/20 md:h-xl"
    :class="rowConfig.class?.(entity)"
  >
    <slot> </slot>
  </div>
</template>

<script setup lang="ts" generic="T extends GenericTableSchema, S extends GenericTableColumnDefinitions<T>">
import { isExternalLink } from "../../../../util/isExternalLink";
import { EntityFromGenericTableColumnDefinition, GenericTableColumnDefinitions } from "../../type.genericTableColumnDefinition";
import { GenericTableRowConfig, GenericTableRowConfigType } from "../../type.genericTableRowConfig";
import { GenericTableSchema } from "../../type.genericTableSchema";
const props = defineProps<{
  entity: EntityFromGenericTableColumnDefinition<T, S>;
  rowConfig: GenericTableRowConfig<T, S>;
}>();
</script>
